<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->

<div class="title has-text-centered">Sorry</div>
<div class="block">We're sorry, it looks like you're not eligible to sign up to A Good Thing. We currently only support the types of organisations listed on the previous page.</div>
<div class="block">If you would like to discuss elibility for your organisation, please contact us at <a href="mailto:hello@agoodthing.org.uk">hello@agoodthing.org.uk</a></div>
<div class="block"><a href={$url('/start/charity/type')}>&lt; Back</a></div>


<script lang="ts">
  import { goto, url } from "@sveltech/routify";


</script>
